import minorII from '../../assets/marshall/headphones/h1.PNG';
import modeII from '../../assets/marshall/headphones/h2.PNG';
import motifANC from '../../assets/marshall/headphones/h3.PNG';
import midANC from '../../assets/marshall/headphones/h4.PNG';
import midBT from '../../assets/marshall/headphones/h5.PNG';
import monitorANC from '../../assets/marshall/headphones/h6.PNG';
import majorIII from '../../assets/marshall/headphones/h7.PNG';
import monitor from '../../assets/marshall/headphones/h9.PNG';
import majorIIIvoice from '../../assets/marshall/headphones/h10.PNG';

const headphones = [
  {
    type: 'headphones',
    id: 1,
    category: 'headphone',
    picture: midANC, // replace with actual image import
    productName: 'MID A.N.C.',
    punchLine: 'AN ICON REBORN',
    playtime: '80+ HOURS OF WIRELESS PLAYTIME',
    productDescription:
      'Meet Major IV, the iconic headphones from Marshall with 80+ solid hours of wireless playtime, wireless charging, and a new ergonomic design. With custom-tuned dynamic drivers, Major IV delivers roaring bass, smooth mids, and brilliant treble for a rich, unrivaled sound you’ll never want to turn off.',
    price: '14,999',
    features: [
      '80+ hours playtime',
      'Wireless charging',
      'Iconic sound',
      'Foldable design',
      'Multi-directional control knob',
    ],
    colors: ['BLACK'],
  },
  {
    type: 'headphones',
    id: 2,
    category: 'headphone',
    picture: midBT, // replace with actual image import
    productName: 'MID BLUETOOTH',
    punchLine: 'SUPERIOR SOUND',
    playtime: '30+ HOURS OF WIRELESS PLAYTIME',
    productDescription:
      'Mid Bluetooth is a premium wireless headphone that delivers superior audio. It features custom-tuned drivers for powerful sound, a 30+ hour battery life, and an ergonomic over-ear design for long listening sessions. Bluetooth aptX gives you exceptional audio quality and freedom from wires.',
    price: '14,499',
    features: [
      'Bluetooth aptX',
      '30+ hours playtime',
      'Superior sound',
      'Comfortable fit',
    ],
    colors: ['BLACK'],
  },
  {
    type: 'headphones',
    id: 3,
    category: 'headphone',
    picture: monitorANC, // replace with actual image import
    productName: 'MONITOR II A.N.C.',
    punchLine: 'SUPERIOR SIGNATURE SOUND',
    playtime: 'UP TO 30 HOURS WITH ANC',
    productDescription:
      'Monitor II A.N.C. headphones deliver high-performance sound like you’ve never heard before. Advanced active noise cancelling technology blocks out the noise, letting you focus on what matters most — the music. Engineered for all-day listening, Monitor II A.N.C. features up to 30 hours of wireless playtime with active noise cancelling and up to 45 hours without.',
    price: '29,999',
    features: [
      'Active noise cancelling',
      '30+ hours playtime with ANC',
      'Customizable EQ',
      'Comfortable ergonomic design',
    ],
    colors: ['BLACK'],
  },
  {
    type: 'headphones',
    id: 4,
    category: 'headphone',
    picture: majorIII,
    productName: 'MAJOR IV',
    punchLine: 'REDEFINING A CLASSIC',
    playtime: '30+ HOURS OF WIRELESS PLAYTIME',
    productDescription:
      'Major IV Bluetooth is the next chapter in the revolutionary history of Marshall. This modern go-to classic has been re-engineered with a straight fit headband, slim 3D hinges, and rebuilt ear cushions. While thicker loop wires with reinforced rubber dampers contribute to the overall solid build quality. Bluetooth aptX gives you the freedom and convenience of a wireless headphone. 30+ hours of playtime on a single charge.',
    price: '12,999',
    features: [
      'Bluetooth aptX',
      '30+ hours playtime',
      'Iconic sound',
      'Custom 40mm dynamic drivers',
    ],
    colors: ['BLACK'],
  },

  {
    type: 'headphones',
    id: 5,
    category: 'onearpod',
    picture: minorII,
    productName: 'MINOR III.',
    punchLine: 'FRONT ROW SOUND WITH ACTIVE NOISE CANCELLATION',
    playtime: '20+ hours total with ANC (6h + 4.5h x3)',
    productDescription:
      'Getting the right sound means having control. MOTIF A.N.C. delivers on that promise. These true wireless headphones come with Active Noise Cancellation, so you can drown out the noise around you and tune into what matters most – the music. You can also customize your level of transparency, so you hear just enough of your surroundings. Motif A.N.C. gives you 20 total hours of wireless playtime with ANC and 26 hours without.',
    price: '19,999',
    features: [
      'Active Noise Cancellation',
      'Bluetooth 5.2',
      'Wireless Charging',
      'IPX5 Water Resistant (earbuds)',
      '20+ hours of total playtime with ANC',
      'Customizable Touch Controls',
    ],
    colors: ['BLACK'],
  },
  {
    type: 'headphones',
    id: 6,
    category: 'onearpod',
    picture: modeII,
    productName: 'MODE II',
    punchLine: 'ALL SOUND, NO FUSS',
    playtime: '25 hours total (5h + 4x charges)',
    productDescription:
      'Minor III brings you Marshall’s signature sound without the fuss. These headphones do all the heavy lifting for you, so all you have to do is grab your music and go. Enjoy 25 total hours of wireless playtime and the freedom of listening without wires. Minor III also gives you the same powerful audio experience as its predecessor, delivering a clear and balanced sound that stays true to the artist’s intent.',
    price: '11,999',
    features: [
      'Bluetooth 5.2',
      'Touch Response',
      '25 hours of wireless playtime',
      'Wireless Charging',
      'IPX4 Water Resistant (earbuds)',
      'Open-fit design for comfort',
    ],
    colors: ['BLACK'],
  },
  {
    type: 'headphones',
    id: 7,
    category: 'onearpod',
    picture: motifANC,
    productName: 'MOTIF A.N.C.',
    punchLine: 'FRONT ROW SOUND WITH ACTIVE NOISE CANCELLATION',
    playtime: '20+ hours total with ANC (6h + 4.5h x3)',
    productDescription:
      'Getting the right sound means having control. MOTIF A.N.C. delivers on that promise. These true wireless headphones come with Active Noise Cancellation, so you can drown out the noise around you and tune into what matters most – the music. You can also customize your level of transparency, so you hear just enough of your surroundings. Motif A.N.C. gives you 20 total hours of wireless playtime with ANC and 26 hours without.',
    price: '19,999',
    features: [
      'Active Noise Cancellation',
      'Bluetooth 5.2',
      'Wireless Charging',
      'IPX5 Water Resistant (earbuds)',
      '20+ hours of total playtime with ANC',
      'Customizable Touch Controls',
    ],
    colors: ['BLACK'],
  },
  {
    type: 'headphones',
    id: 8,
    category: 'onear',
    picture: monitor,
    productName: 'MONITOR',
    punchLine: 'LIGHT ON YOUR EARS, HEAVY ON SOUND',
    playtime: '12 hours of wireless playtime',
    productDescription:
      'Minor II Bluetooth is an in-ear Bluetooth headphone engineered to stay in place and deliver high-quality audio. With 12 hours of wireless playtime and a flexible ear-fit system, Minor II Bluetooth combines comfort and a secure fit with exceptional sound quality. It features Bluetooth aptX for lossless wireless sound at a range of up to 10 metres and a magnetic pause function for convenience.',
    price: '10,999',
    features: [
      'Bluetooth aptX',
      '12 hours of wireless playtime',
      'Magnetic pause function',
      'Flexible ear-fit system',
      'Multi-directional control knob',
    ],
    colors: ['BLACK'],
  },
  {
    type: 'headphones',
    id: 9,
    category: 'onear',
    picture: majorIIIvoice,
    productName: 'MAJOR III VOICE',
    punchLine: 'COMPACT SIGNATURE SOUND',
    playtime: '',
    productDescription:
      'Mode headphones deliver huge sound in a small package. Custom tuned dynamic drivers produce high-output sound with minimal distortion. The unique in-ear design anchors to your ear and helps keep the headphones in place while staying comfortable. Mode also comes equipped with a microphone and remote for use with your mobile phone.',
    price: '4,499',
    features: [
      'Custom tuned drivers',
      'In-ear secure fit',
      'Microphone and remote',
      'L-shape plug for durability',
      'Tangle-resistant cord',
    ],
    colors: ['BLACK'],
  },
];

export default headphones;
